import { useLingui } from '@lingui/react/macro';
import { Badge } from '@utima/ui';
import { memo } from 'react';

export type VerifiedBadgeProps = {
  verified: boolean;
};

export const VerifiedBadge = memo(function VerifiedBadge({
  verified,
}: VerifiedBadgeProps) {
  const { t } = useLingui();

  return verified ? (
    <Badge variant='success' size='sm'>
      {t`Verified`}
    </Badge>
  ) : (
    <Badge variant='danger' size='sm'>
      {t`Not verified`}
    </Badge>
  );
});
